import { Left } from './Left';
import { Center } from './Center';
import { Right } from './Right';
import { Search } from './Search';
import classNames from 'classnames';

export const Content = ({ children, className, containerClassName, ...r }) => {
  const classnames = classNames('container grid gap-16 gap-32_lg', className);
  const _containerClassName = classNames("content", containerClassName);
  return (
    <div className={_containerClassName} {...r}>
      <div className={classnames}>{children}</div>
    </div>
  );
};

Content.Left = Left;
Content.Center = Center;
Content.Right = Right;
Content.Search = Search;
